"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var transform_layout_children_1 = __importDefault(require("../../_helpers/transform-layout-children"));
var layout_margin_reset_1 = __importDefault(require("../../_helpers/layout-margin-reset"));
var tokens_1 = require("../../tokens");
var gridTemplateColumns = {
    '1/2 1/2': 'repeat(2, 1fr)',
    '1/3 1/3 1/3': 'repeat(3, 1fr)',
    '2/3 1/3': '2fr 1fr',
    '1/3 2/3': '1fr 2fr',
    '1/4 1/4 1/4 1/4': "repeat(4, 1fr)",
    '2/4 1/4 1/4': '2fr 1fr 1fr',
    '1/4 2/4 1/4': '1fr 2fr 1fr',
    '1/4 1/4 2/4': '1fr 1fr 2fr',
    '3/4 1/4': '3fr 1fr',
    '1/4 3/4': '1fr 3fr'
};
var gutterOptions = {
    none: 0,
    xsmall: tokens_1.spacing.xsmall,
    small: tokens_1.spacing.small,
    medium: tokens_1.spacing.medium,
    large: tokens_1.spacing.xlarge
};
var ColumnLayout = function (props) { return (React.createElement(ColumnLayout.Element, __assign({ gutter: props.gutter, distribution: props.distribution }, automation_attribute_1.default('column-layout')), transform_layout_children_1.default(props, ColumnLayout.Item, 'column-layout.item'))); };
ColumnLayout.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-gap: ", ";\n  grid-template-columns: 1fr;\n\n  /* Placeholder width media feature until we have global variables for breakpoints */\n  @media (min-width: 768px) {\n    grid-template-columns: ", ";\n  }\n\n  & > *:empty {\n    display: none;\n  }\n\n  ", ";\n"], ["\n  display: grid;\n  grid-gap: ", ";\n  grid-template-columns: 1fr;\n\n  /* Placeholder width media feature until we have global variables for breakpoints */\n  @media (min-width: 768px) {\n    grid-template-columns: ", ";\n  }\n\n  & > *:empty {\n    display: none;\n  }\n\n  ", ";\n"])), function (props) { return gutterOptions[props.gutter]; }, function (props) { return gridTemplateColumns[props.distribution]; }, layout_margin_reset_1.default());
ColumnLayout.Item = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
ColumnLayout.defaultProps = {
    gutter: 'medium',
    distribution: '1/2 1/2'
};
exports.default = ColumnLayout;
var templateObject_1, templateObject_2;
//# sourceMappingURL=column-layout.js.map